import { 
    UPDATE_SETTINGS_FAILURE,
    UPDATE_SETTINGS_REQUEST,
    UPDATE_SETTINGS_RESET,
    UPDATE_SETTINGS_SUCCESS,
    FETCH_SETTINGS_FAILURE,
    FETCH_SETTINGS_REQUEST,
    FETCH_SETTINGS_SUCCESS
    
} from "./SettingsTypes"


import axios from "axios"

export const updateSettingsReset = () => {
    return {
        type: UPDATE_SETTINGS_RESET,
    }
}

const updateSettingsRequest = () => {
    return {
        type: UPDATE_SETTINGS_REQUEST,
    }
}

const updateSettingsSuccess = success => {
    return {
        type: UPDATE_SETTINGS_SUCCESS,
        payload: success
    }
}

const updateSettingsFailure = error => {
    return {
        type: UPDATE_SETTINGS_FAILURE,
        payload : error
    }
}

export const updateSettings = (data) => {

    return (dispatch) => {

        dispatch(updateSettingsRequest());
        
        
        
        axios.post('/updateSettings', data)
        .then(response => {
            const settings = response.data
            dispatch(updateSettingsSuccess(settings))
            
        })
        .catch(error => {
            const errorMsg = error.message
            dispatch(updateSettingsFailure(errorMsg))
        })
        
    }

}



const fetchSettingsRequest = () => {
    return {
        type: FETCH_SETTINGS_REQUEST,
    }
}

const fetchSettingsSuccess = success => {
    return {
        type: FETCH_SETTINGS_SUCCESS,
        payload: success
    }
}

const fetchSettingsFailure = error => {
    return {
        type: FETCH_SETTINGS_FAILURE,
        payload : error
    }
}

export const fetchSettings = (data) => {
    
    return (dispatch) => {
        
        dispatch(fetchSettingsRequest());
        
        
        axios.post('/fetchSettings' , data)
        .then(response => {
            const settings = response.data
            dispatch(fetchSettingsSuccess(settings))
            
         
        })
        .catch(error => {
            const errorMsg = error.message
            dispatch(fetchSettingsFailure(errorMsg))
        })
        
    }

}
